/* global window */

import _ from 'lodash';
import * as types from '../../../../store/mutation-types';
import { COUPON_CHECK_WAIT, NOT_INCLUDED_INDEX } from '../../../../store/constants';
import {
  getCheckoutUrl,
  parseProjectPaymentMethods,
  getInitialPaymentMethod,
  isPaymentModeActive,
} from '../../../../helpers/map-helpers';
import { getQueryParams } from '../../../../helpers/fetch-helpers.js';

export default {
  props: ['open', 'activeProject'],
  data() {
    return {
      couponCode: null,
      coupon: null,
      loadingCoupon: false,
      form: {},
      uploadError: false,
      uploading: false,
      buying: false,
      errorPurchasing: false,
      selectedPicSize: null,
      processComplete: false,
      projectIdsByCoupon: null,
      paymentType: null,
    };
  },
  created() {
    this.$upload.new('upload-mobile-photo', {
      maxSizePerFile: 50000,
      url: '/api/v1/uploads',
      onSuccess(res) {
        this.uploading = false;
        this.form.uploadIdentifier = res.body.upload.identifier;
        this.form.uploadName = res.body.upload.file_name;
      },
      onError() {
        this.uploading = false;
      },
      onSelect() {
        this.uploading = true;
      },
    });
    this.paymentType = getInitialPaymentMethod(this.paymentMethods) || 'paypal';
  },
  computed: {
    projects() {
      if (this.projectIdsByCoupon !== null && this.paymentType === 'coupon') {
        return this.$store.getters.projectsWithActivePicAreasAsArray
          .filter(p => this.projectIdsByCoupon.indexOf(p.id) !== NOT_INCLUDED_INDEX);
      }

      return this.$store.getters.projectsWithActivePicAreasAsArray;
    },
    selectedProject() {
      return this.$store.state.map.projects[this.form.projectId];
    },
    paymentMethods() {
      return parseProjectPaymentMethods(this.selectedProject);
    },
    purchase() {
      return this.$store.state.map.purchase;
    },
    apiToken() {
      return this.$store.state.auth.apiToken;
    },
    purchaseComplete() {
      return this.purchase.status === 'paid';
    },
    isFormDisabled() {
      if (this.paymentType === 'coupon') {
        return !this.coupon || this.loadingCoupon || this.coupon && !this.coupon.available;
      }
      if (this.paymentType === 'paypal') {
        return !this.selectedPicSize;
      }
      if (this.paymentType === 'mercadopago') {
        return !this.selectedPicSize;
      }

      return true;
    },
  },
  methods: {
    toggleOpen() {
      this.resetEverything();
      this.$store.commit(types.TOGGLE_MOBILE_COUPON, !this.open);
    },
    checkCouponCode: _.debounce(
      function () {
        this.loadingCoupon = true;
        this.$store.dispatch('checkCoupon', { couponCode: this.couponCode.toUpperCase() })
          .then(coupon => {
            this.loadingCoupon = false;
            if (coupon) {
              this.coupon = coupon;
              if (!_.isEmpty(this.coupon.projects)) {
                this.projectIdsByCoupon = this.coupon.projects.map(project => project.id);
                this.form.projectId = this.projectIdsByCoupon[0];
              }
              this.$store.commit(types.SAVE_COUPON, this.couponCode.toUpperCase());
            } else {
              this.coupon = null;
              this.projectIdsByCoupon = null;
              this.$store.commit(types.RESET_COUPON);
            }
          });
      },
      COUPON_CHECK_WAIT,
      {
        leading: true,
      }
    ),
    buy() {
      /* eslint-disable no-else-return, consistent-return */
      this.buying = true;
      this.errorPurchasing = false;
      const area = this.selectedProject.areas.find(a => a.areaType === 'pic');
      if (!area) return;
      this.$store.dispatch('addPlotToCart', {
        areaId: area.id,
        sideLength: Math.floor(Math.sqrt(
          (this.paymentType === 'coupon') ? this.coupon.campaignAmount : this.selectedPicSize
        )),
      })
        .then(() => this.$store.dispatch('startPurchase', this.form.projectId))
        .then(
          () =>
            this.$store.dispatch('updatePicInformation', {
              name: this.form.name,
              email: this.form.email,
              uploadIdentifier: this.form.uploadIdentifier,
            }),
          () => {
            throw new Error('pic_selection_error');
          }
        )
        .then(() => {
          const center = this.purchase.center;
          if (this.paymentType === 'coupon') {
            this.$store.commit(types.SET_MAP_CENTER, center);

            return this.$store.dispatch('checkoutPurchase');
          } else {
            window.location.href = getCheckoutUrl({
              token: this.apiToken,
              paymentMode: this.paymentType,
            });
          }
        })
        .then(() => {
          if (this.paymentType === 'coupon') {
            this.$store.commit(types.CLEAR_CART);
            this.buying = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch('cancelPurchase');
          this.buying = false;
          this.errorPurchasing = err;
        });
      /* eslint-enable no-else-return, consistent-return */
    },
    resetEverything() {
      this.form = {};
      this.buying = false;
      this.coupon = null;
      this.couponCode = null;
      this.errorPurchasing = false;
      this.$store.commit(types.RESET_PURCHASE);
      this.$store.commit(types.CLEAR_CART);
    },
    share() {
      const url = encodeURIComponent(`${window.location.href}&s=${this.purchase.shareHash}`);
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank', 'height=600,width=400');
    },
  },
  watch: {
    open(value, oldValue) {
      const TIME_BEFORE_MAP_CENTER = 500;
      const params = getQueryParams();
      if(this.purchaseComplete && params.specificPlot === 'true') {
        const specificPlotCenter = params.center.split(',');
        setTimeout(() => {
          this.$store.commit(types.SET_MAP_CENTER, specificPlotCenter);
        }, TIME_BEFORE_MAP_CENTER);
      }
      else if (value && value !== oldValue && this.purchaseComplete) {
        setTimeout(() => {
          this.$store.commit(types.SET_MAP_CENTER, this.purchase.center);
        }, TIME_BEFORE_MAP_CENTER);
      }
    },
    selectedProject() {
      if (!isPaymentModeActive(this.paymentMethods, this.paymentType)) {
        this.paymentType = getInitialPaymentMethod(this.paymentMethods);
      }
    },
  },
};
